import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 25","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ai-education"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6 17.5699V11.1699L12 15.0699L18 11.1699V17.5699C18 19.5029 15.3137 21.0699 12 21.0699C8.68629 21.0699 6 19.5029 6 17.5699Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6 11.6698V17.5698C6 19.5028 8.68629 21.0698 12 21.0698C15.3137 21.0698 18 19.5028 18 17.5698V11.6698M21 9.46982V15.0698M2.3125 8.3667L2 8.56982L12 15.0698L22 8.56982L12 2.06982L11.6875 2.27295","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6.25 2.56982L6.76972 3.8001L8 4.31982L6.76972 4.83955L6.25 6.06982L5.73028 4.83955L4.5 4.31982L5.73028 3.8001L6.25 2.56982Z","strokeWidth":"props.strokeWidth"}}]}]};

const AiEducation = Vue.extend<IconProps>({
  name: 'AiEducationIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ai-education',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AiEducation;
